import { Empty } from '@byecode/ui/components/Empty'
import { IconFont } from '@byecode/ui/components/IconFont'
import * as React from 'react'

interface PageEmptyProps {}

export const PageEmpty: React.FunctionComponent<PageEmptyProps> = () => {
    return (
        <Empty
            icon={<IconFont size={32} color="var(--color-gray-400)" type="PageBroadContent" />}
            description="未搜索到页面"
            styles={{
                root: {
                    border: '1.5px  dashed var(--color-gray-200)',
                    backgroundColor: 'var(--color-gray-25)',
                    borderRadius: 6,
                    padding: '12px 0',
                    margin: '6px 0'
                },
                content: {
                    fontSize: 12
                }
            }}
        />
    )
}
